import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MapsService, SharedService, MeteoObservationService, 
  HydrologyService, AgroService, SynopticService, RadarService,
  MapsInteractiveService } from './../../../services';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { icon, latLng, marker,MarkerClusterGroup, polyline, tileLayer, layerGroup, 
  divIcon, geoJSON, gridLayer, LeafletEvent, LeafletMouseEvent } from 'leaflet';
declare var L: any;//Declare leaflet lib and plugin
declare var GeoTIFF;
declare var rastertools;
import { belarus } from './belarus';
// import 'leaflet.snogylop/src/leaflet.snogylop.js';
import 'leaflet';
import { timingSafeEqual } from 'crypto';
// import 'leaflet.markercluster';
// import 'leaflet.fullscreen/Control.FullScreen.js'; // full screen

@Component({
  selector: 'widget-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.scss']
})
export class MapsComponent implements OnInit {

  constructor(
    private _synoptic: SynopticService,
    private _meteo: MeteoObservationService,
    private _radar: RadarService,
    private _hydrology: HydrologyService,
    private _agro: AgroService,
    private _maps: MapsInteractiveService,
    private _shared: SharedService,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
  ) { }

  isSmallIcons;

  mapTypeCurrent = 0;
  /* Inside settings: */
  mapTypes = [
    { enable: true, title: 'ПРОГНОЗ', url: '/weather/synoptic' },
    { enable: true, title: 'ТЕКУЩАЯ ПОГОДА', url: '/observation/meteo-observation' },
    { enable: true, title: 'РАДАРЫ', url: '/observation/radars' },
    { enable: true, title: 'ГИДРО', url: '/observation/hydrology' },
    { enable: false, title: 'АГРО', url: '/observation/agro' }
  ];
  onScroll(e) {
    L.DomEvent.stopPropagation(e);
  }
  onClick(e) {
    e.stopPropagation();
  }
  mouseEnter() {
    this.map.scrollWheelZoom.disable();
  }
  mouseLeave() {
    this.map.scrollWheelZoom.enable();
  }
  map: L.Map;
  public fullscreenOptions: {[key:string]:any} = {
    position: 'topright',
    // title: 'View Fullscreen',
    // titleCancel: 'Exit Fullscreen',
  };
  onMapReady(map: L.Map) {
    this.map = map;

    // let fullScreenBtn = L.control.fullscreen({
    //   position: 'topright', // change the position of the button can be topleft, topright, bottomright or bottomleft, defaut topleft
    //   title: '', // change the title of the button, default Full Screen
    //   titleCancel: '', // change the title of the button when fullscreen is on, default Exit Full Screen
    //   content: null, // change the content of the button, can be HTML, default null
    //   forceSeparateButton: false, // force seperate button to detach from zoom buttons, default false
    //   forcePseudoFullscreen: true, // force use of pseudo full screen even if full screen API is available, default false
    //   fullscreenElement: false // Dom element to render in full screen, false by default, fallback to map._container
    // });
    // fullScreenBtn.addTo(this.map);
    
    this.map.getRenderer(this.maskBelarusAlpha).options.padding = 100; // preload render when moving
    this.maskBelarusAlpha.addTo(this.map);
    this.maskBelarusAlpha.on('click', (e) => {
      L.DomEvent.stopPropagation(e);
    });

    this.map.getRenderer(this.maskBelarus).options.padding = 100; // preload render when moving
    // this.maskBelarusAlpha.addTo(this.map);
    this.maskBelarus.on('click', (e) => {
      L.DomEvent.stopPropagation(e);
    });
    
    var southWest = L.latLng(60, 20),
    northEast = L.latLng(45, 34);
    var bounds = L.latLngBounds(southWest, northEast);

    map.setMaxBounds(bounds);
    L.control.zoom({
      position: 'topright'
    }).addTo(this.map);
  }
  options = {
    layers: [
      new L.TileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        boundary: belarus,
        detectRetina: true,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Белгидромет'
      })
    ],
    zoom: 6,
    minZoom: 6,
    hideSingleBase: true,
    zoomControl: false,
    center: latLng([53.8, 28]),
  };
  showMaskBelarus = false;
  showMaskBelarusAlpha = false;
  maskBelarus = L.geoJson(belarus, {
    invert: true,
    // fillColor: 'blue',
    weight: 0,
    opacity: 1,
    color: 'white',
    // dashArray: '3',
    fillOpacity: 1
  });
  maskBelarusAlpha = L.geoJson(belarus, {
    invert: true,
    // fillColor: 'blue',
    weight: 0,
    opacity: .5,
    color: 'white',
    // dashArray: '3',
    fillOpacity: .5
  });

  selectedCity;
  canIuseData = true;
  runAction() {
    this.canIuseData = false;
    setTimeout(()=>this.canIuseData=true,1000);
    if (this.mapTypeCurrent === 0) {
      this.clearRadarMarkers();
      this.currDate = new Date();
      this.getSynopticByDate(this.formatDate(this.currDate), 'current');
      this.getSynopticByDate(this.formatDate(new Date(this.currDate.getTime() + 86400000)), 'next');
      
      if (this.haveCurrent() && this.checkFirstDay()) {
        this.STATE_INTERACTIVE = this.STATES_INTERACTIVE.CUR_DAY;
        this.ss = 'd';
        this.currDate = new Date();
        this.getMarkerSynopticByDate('current');
      } else if (this.haveNext()) {
        this.STATE_INTERACTIVE = this.STATES_INTERACTIVE.NEXT_NIGHT;
        this.ss = 'n';
        this.currDate = new Date();
        this.getMarkerSynopticByDate('next');
      } else {
        this.resultLayer && this.map.removeLayer(this.resultLayer);
        this.maskBelarus && this.map && this.map.removeLayer && this.map.removeLayer(this.maskBelarus);
        this.maskBelarusAlpha && this.map && this.map.removeLayer && this.map.removeLayer(this.maskBelarusAlpha);
        this.maskBelarusAlpha && this.maskBelarusAlpha.addTo && this.map && this.maskBelarusAlpha.addTo(this.map);
        // this.showMaskBelarus = false;
        // this.showMaskBelarusAlpha = false;
        // this.showMaskBelarusAlpha = true;
      }
    } else if (this.mapTypeCurrent === 1) {
      this.clearRadarMarkers();
      this.getMeteo10Min();
    } else if (this.mapTypeCurrent === 2) {
      this.clearRadarMarkers();
      this.getRadars();
    } else if (this.mapTypeCurrent === 3) {
      this.clearRadarMarkers();
      this.getGidro();
    } else if (this.mapTypeCurrent === 4) {
      this.clearRadarMarkers();
      this.getAgroGeoTIFF();
      this.getAgroDateGenerate();
    } 
  }

  getDateTime(dateUTC) {
    return new Date(dateUTC).setUTCHours(new Date(dateUTC).getUTCHours() + 
      (!this.timeUTC ? Number(this.selectedCity.timezone) : 0));
  }
  addZero(num) {
    return String(num).length == 1 ? `0${num}` : num;
  }
  getDate(datetime) {
    return `${this.addZero(new Date(datetime).getUTCDate())}.`+
    `${this.addZero(new Date(datetime).getUTCMonth()+1)}.${new Date(datetime).getUTCFullYear()} 
    ${this.addZero(new Date(datetime).getUTCHours())}:${this.addZero(new Date(datetime).getUTCMinutes())}`;
  }

  loading = false;





  // SYNOPTIC

  STATES_INTERACTIVE = {
    CUR_NIGHT: 'CUR_NIGHT',
    CUR_DAY: 'CUR_DAY',
    NEXT_NIGHT: 'NEXT_NIGHT',
    NEXT_DAY: 'NEXT_DAY'
  };
  STATE_INTERACTIVE = this.STATES_INTERACTIVE.CUR_DAY;
  ss = 'd';
  setSTATE_INTERACTIVE(state) {
    if (state === this.STATES_INTERACTIVE.CUR_NIGHT) {
      this.STATE_INTERACTIVE = this.STATES_INTERACTIVE.CUR_NIGHT;
      this.ss = 'n';
      this.currDate = new Date();
      this.getMarkerSynopticByDate('current');
    } else if (state === this.STATES_INTERACTIVE.CUR_DAY) {
      this.STATE_INTERACTIVE = this.STATES_INTERACTIVE.CUR_DAY;
      this.ss = 'd';
      this.currDate = new Date();
      this.getMarkerSynopticByDate('current');
    } else if (state === this.STATES_INTERACTIVE.NEXT_NIGHT) {
      this.STATE_INTERACTIVE = this.STATES_INTERACTIVE.NEXT_NIGHT;
      this.ss = 'n';
      this.currDate = new Date();
      this.getMarkerSynopticByDate('next');
    } else if (state === this.STATES_INTERACTIVE.NEXT_DAY) {
      this.STATE_INTERACTIVE = this.STATES_INTERACTIVE.NEXT_DAY;
      this.ss = 'd';
      this.currDate = new Date();
      this.getMarkerSynopticByDate('next');
    }
  }

  listSynoptic = [];
  cities = {
    1: {name:'Брест',lat: 52.08963261363972,lng: 23.6810302734375},    
    2: {name:'Гродно',lat: 53.66417110963306,lng: 23.851318359375},    
    3: {name:'Минск',lat: 53.90110181472825,lng: 27.564697265624996},
    4: {name:'Витебск',lat: 55.18514054299152,lng: 30.2069091796875},
    5: {name:'Гомель',lat: 52.419172910580876,lng: 31.0089111328125},    
    6: {name:'Могилёв',lat: 53.904338156274704,lng: 30.3387451171875}
  };
  winds = {
    0: 'перем-ый',
    1: 'северный',
    2: 'с-в',
    3: 'восточный',
    4: 'ю-в',
    5: 'южный',
    6: 'ю-з',
    7: 'западный',
    8: 'с-з',
    9: 'неуст-ый'
  };
  cities2 = {
    1: {name:'Брест',lat: 52.08963261363972,lng: 23.6810302734375},    
    2: {name:'Гродно',lat: 53.66417110963306,lng: 23.851318359375},    
    3: {name:'Минск',lat: 53.90110181472825,lng: 27.564697265624996},
    4: {name:'Витебск',lat: 55.18514054299152,lng: 30.2069091796875},
    5: {name:'Гомель',lat: 52.419172910580876,lng: 31.0089111328125},    
    6: {name:'Могилёв',lat: 53.904338156274704,lng: 30.3387451171875}
  };
  winds2 = {
    0: 'перем-ый',
    1: 'северный',
    2: 'с-в',
    3: 'восточный',
    4: 'ю-в',
    5: 'южный',
    6: 'ю-з',
    7: 'западный',
    8: 'с-з',
    9: 'неуст-ый'
  };
  checkCurrDate(d) {
    let day = (new Date(d)).getDate();
    let currDay = (new Date()).getDate();
    return day === currDay;
  }
  checkFirstHalfDay() {
    return (new Date()).getHours() < 12
  }
  checkFirstNight() {
    return (new Date()).getHours() < 9
  }
  checkFirstDay() {
    return (new Date()).getHours() < 21
  }
  roundTemp(t) {
    return Math.round(Number(t));
  }
  parsePlus(t) {
    t = this.roundTemp(t)
    return t > 0 ? '+'+t : t;
  }
  getPlus1Day() {
    return new Date(this.currDate.getTime() + 86400000);
  }
  haveCurrent() {
    return this.array.filter(v => v.current).length > 0;
  }
  haveNext() {
    return this.array.filter(v => v.next).length > 0;
  }

  currDate;
  currDay = [];
  nextDay = [];
  array = [
    { current:undefined, next: undefined, name: 'Брест'},
    { current:undefined, next: undefined, name: 'Гродно'},
    { current:undefined, next: undefined, name: 'Минск'},
    { current:undefined, next: undefined, name: 'Витебск'},
    { current:undefined, next: undefined, name: 'Гомель'},
    { current:undefined, next: undefined, name: 'Могилёв'}
  ];
  formatDate = function (datum) {
    let date = new Date(datum);
    let m = (date.getMonth() + 1).toString();
    if ((String(m)).length == 1) m = '0' + m;
    let d = date.getDate().toString();
    if ((String(d)).length == 1) d = '0' + d;
    return date.getFullYear() + '-' + m + '-' + d;
  };
  getUIableTemperature(min,max) {
    min = Number(min);
    max = Number(max);
    let htmlMIN = `<span class="${min <= 0 ? 'min' : 'max'}">${this.parsePlus(min)}</span>`;
    let htmlMAX = `<span class="${max <= 0 ? 'min' : 'max'}">${this.parsePlus(max)}</span>`;

    if (min > 0 && max > 0) {
      if (min < max) {
        return `${htmlMIN}..${htmlMAX}`;
      } else if (max < min) {
        return `${htmlMAX}..${htmlMIN}`;
      } else {
        return `${htmlMIN}`;
      }
    } else if (min > 0 || max > 0) {
      if (min < max) {
        return `${htmlMIN}..${htmlMAX}`;
      } else if (max < min) {
        return `${htmlMAX}..${htmlMIN}`;
      } else {
        return `${htmlMIN}`;
      }
    } else {
      if (Math.abs(min) < Math.abs(max)) {
        return `${htmlMIN}..${htmlMAX}`;
      } else if (Math.abs(max) < Math.abs(min)) {
        return `${htmlMAX}..${htmlMIN}`;
      } else {
        return `${htmlMIN}`;
      }
    }
  }
  getSynopticByDate(date, type) {   
    this._synoptic.getByDate(date).subscribe(
      res => {
        this.currDay = res;
        // this.array = [
        //   {name: 'Брест', id:undefined},
        //   {name: 'Гродно', id:undefined},
        //   {name: 'Минск', id:undefined},
        //   {name: 'Витебск', id:undefined},
        //   {name: 'Гомель', id:undefined},
        //   {name: 'Могилёв', id:undefined}
        // ]
        res.forEach(v => {
          if (v.city_id === 1) {
            this.array[0][type] = v;
          } else if (v.city_id === 2) {
            this.array[1][type] = v;
          } else if (v.city_id === 3) {
            this.array[2][type] = v;
          } else if (v.city_id === 4) {
            this.array[3][type] = v;
          } else if (v.city_id === 5) {
            this.array[4][type] = v;
          } else if (v.city_id === 6) {
            this.array[5][type] = v;
          } else if (v.city_id === 7) {
            this.array[7][type] = v;
          }
        });
        if (this.haveCurrent() && this.checkFirstDay()) {
          this.STATE_INTERACTIVE = this.STATES_INTERACTIVE.CUR_DAY;
          this.ss = 'd';
          this.currDate = new Date();
          this.getMarkerSynopticByDate('current');
        } else if (this.haveNext()) {
          this.STATE_INTERACTIVE = this.STATES_INTERACTIVE.NEXT_NIGHT;
          this.ss = 'n';
          this.currDate = new Date();
          this.getMarkerSynopticByDate('next');
        }
      },
      err => {}
    );
  }

  getMarkerSynopticByDate(type) {
    let getStyleStationMarker = (html) => (L.divIcon({ 
      className: 'custom-synoptic-weather-icon', 
      iconSize: [1, 1], 
      iconAnchor: [1, 1],
      html: `
      <div class="container-synoptic-weather">
        <div class="name">${html.name}</div>
        <div class="body-str1">
          <img src="assets/icons-synoptic/${this.ss}${html[type][`ph_${this.ss}_id`]}.png" alt="weather">
          &nbsp;
          ${this.getUIableTemperature(html[type][`temp_${this.ss}_min`], html[type][`temp_${this.ss}_max`])}
        </div>
        <div class="body-str2">
          Ветер ${html[type][`wind_${this.ss}`]} м/с 
          <svg class="d${html[type][`veter_${this.ss}_id`]}" viewBox="2 2 22 22" width="14px" height="14px">
            <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"/>
          </svg>
        </div>
      </div>
      <div class="triangle"></div>
      <div class="triangle2"></div>
      <div class="circle"></div>` 
    }));
    // ${this.winds2[html[type][`veter_${this.ss}_id`]]}
    let getStationMarker = (lat, lng, html) => L.marker([lat, lng], { icon: getStyleStationMarker(html) });
    this.resultLayer && this.map.removeLayer(this.resultLayer);
    this.resultLayer = layerGroup();

    this.array.filter(v => v[type]).forEach((v, i) => {
      // let marker = 
      v['name'] = this.cities2[v[type].city_id].name;
      this.resultLayer.addLayer(
        getStationMarker(
          this.cities2[v[type].city_id].lat, 
          this.cities2[v[type].city_id].lng, v)
        .on('click', () => {}));

    });
    this.resultLayer.addTo(this.map);
    this.maskBelarus && this.map.removeLayer(this.maskBelarus);
    this.maskBelarusAlpha && this.map.removeLayer(this.maskBelarusAlpha);
    this.maskBelarusAlpha.addTo(this.map);
    this.loading = false;
    
  }
  






  //RADARS
  density = 60;
  ArrayOfRadarsByRadar = {};
  btnsPlaceRadars = [];
  changeViewLayer(i) {
    this.btnsPlaceRadars[i].active = !this.btnsPlaceRadars[i].active;
    if (this.btnsPlaceRadars[i].active) {
      // console.log(this.ArrayOfRadarsByRadar, this.btnsPlaceRadars[i]);
      if (!this.btnsPlaceRadars[i].title.includes('UKBB')) {
        this.ArrayOfRadarsByRadar[this.btnsPlaceRadars[i].radar] && this.ArrayOfRadarsByRadar[this.btnsPlaceRadars[i].radar].forEach(v => {
          v.addTo(this.map);
        });
      }
    } else {
      this.ArrayOfRadarsByRadar[this.btnsPlaceRadars[i].radar] && this.ArrayOfRadarsByRadar[this.btnsPlaceRadars[i].radar].forEach(v => {
        this.map.removeLayer(v);
      });
    }
  }
  showLegend = true;
  legendsOfmap = [
    {title:'Слоистобразная облачность', color: '#FFFFFF'},
    {title:'Осадки слабые', color: '#9BEA8F'},
    {title:'Осадки умеренные', color: '#58FF42'},
    {title:'Осадки сильные', color: '#47C278'},
    {title:'Конвективная облачность', color: '#9BE1FF'},
    {title:'Конвективные осадки слабые', color: '#4793F8'},
    {title:'Конвективные осадки умерен.', color: '#0C59FF'},
    {title:'Конвективные осадки сильные', color: '#6153C1'},
    {title:'Гроза - вероятность 30-70%', color: '#FF93A3'},
    {title:'Гроза - вероятность 70-90%', color: '#FF3F35'},
    {title:'Гроза - вероятность 90-100%', color: '#C20511'},
    {title:'Град слабый', color: '#FFEA0A'},
    {title:'Град умеренный', color: '#FF9811'},
    {title:'Град сильный', color: '#A84C06'},
    {title:'Шквал слабый', color: '#DDA8FF'},
    {title:'Шквал умеренный', color: '#E859FF'},
    {title:'Шквал сильный', color: '#BE1CFF'}
  ];
  meteo = new Array();
  markers = new Array();
  async getRadars() {
    this.map.removeLayer(this.maskBelarus);
    this.map.removeLayer(this.maskBelarusAlpha);

    this.resultLayer && this.map.removeLayer(this.resultLayer);
    this.resultLayer = layerGroup();
    // this.map = map;
    let radars=new Array();
    for(let i = 0; i < 17; i++) {
      this.meteo[i] = layerGroup();
    }
    let radarsRect = [];
    this.markers = [];
    // (L.marker([51.9,36.13]).bindPopup('RAKU (Курск) 2020-02-12 08:00:00')).addTo(this.resultLayer);
    // (L.marker([56.39,30.64]).bindPopup('RAVL (В.Луки) 2020-02-12 08:00:00')).addTo(this.resultLayer);
    // (L.marker([53.21,34.19]).bindPopup('RUDB (Брянск) 2020-02-12 08:00:00')).addTo(this.resultLayer);
    // (L.marker([54.85,32]).bindPopup('RUDL (Смоленск) 2020-02-12 08:10:00')).addTo(this.resultLayer);
    // (L.marker([50.33,30.9]).bindPopup('UKBB (Борисполь) 2020-02-12 08:07:00')).addTo(this.resultLayer);
    // (L.marker([52.12,23.9]).bindPopup('UMBB (Брест) 2020-02-12 05:50:00')).addTo(this.resultLayer);
    // (L.marker([52.52,31.02]).bindPopup('UMGG (Гомель) 2020-02-12 08:10:00')).addTo(this.resultLayer);
    // (L.marker([55.14,30.35]).bindPopup('UMII (Витебск) 2020-02-12 08:10:00')).addTo(this.resultLayer);
    // (L.marker([53.88,28.03]).bindPopup('UMMN (Минск-2) 2020-02-12 08:10:00')).addTo(this.resultLayer);
    this.resultLayer.addTo(this.map);
    let radarsListNames = {
      RUAD:"RUAD (Адлер)",
      RUAP:"RUAP (Анапа)",
      RUDX:"RUDX (Архангельск)",
      RABG:"RABG (Белгород)",
      UKBB:"UKBB (Борисполь)",
      UMBB:"UMBB (Брест)",
      RUDB:"RUDB (Брянск)",
      RUWJ:"RUWJ (Валдай)",
      RAVN:"RAVN (Внуково)",
      RAVL:"RAVL (В.Луки)",
      RUDG:"RUDG (Волгоград)",
      RUDV:"RUDV (Вологда)",
      UMGG:"UMGG (Гомель)",
      RUDE:"RUDE (Долгопрудный)",
      RUEK:"RUEK (Екатеринбург)",
      UKDE:"UKDE (Запорожье)",
      RUDI:"RUDI (Ижевск)",
      RUDZ:"RUDZ (Казань)",
      RUKL:"RUKL (Калуга)",
      RAKW:"RAKW (Киров)",
      RUDK:"RUDK (Кострома)",
      RAKD:"RAKD (Краснодар)",
      RAKU:"RAKU (Курск)",
      RUKT:"RUKT (Москва)",
      UMMN:"UMMN (Минск-2)",
      UMII:"UMII (Витебск)",
      RUDM:"RUDM (Минводы)",
      RUDN:"RUDN (Н.Новгород)",
      RUDO:"RUDO (Оренбург)",
      RUPM:"RUPM (Пермь)",
      RUDP:"RUDP (Петрозаводск)",
      RURD:"RURD (Ростов-на-Дону)",
      RASM:"RASM (Самара)",
      RUDL:"RUDL (Смоленск)",
      RUSI:"RUSI (Сочи)",
      RUSP:"RUSP (СПБ)",
      RUDT:"RUDT (Ставрополь)",
      RUTW:"RUTW (Тверь)",
      RATL:"RATL (Тула)",
      RUUL:"RUUL (Ульяновск)",
      UMMG:"UMMG (Гродно)"
    };
    let radarsList = [
      {radarId:0,lon:39.93,lat:43.45,info:"RUAD (Адлер)"},
      {radarId:1,lon:37.363,lat:45.00515,info:"RUAP (Анапа)"},
      {radarId:2,lon:40.51,lat:64.625,info:"RUDX (Архангельск)"},
      {radarId:3,lon:36.29,lat:50.48,info:"RABG (Белгород)"},
      {radarId:4,lon:30.9,lat:50.33,info:"UKBB (Борисполь)"},
      {radarId:5,lon:23.9,lat:52.12,info:"UMBB (Брест)"},
      {radarId:6,lon:34.19,lat:53.21,info:"RUDB (Брянск)"},
      {radarId:7,lon:33.27,lat:57.95,info:"RUWJ (Валдай)"},
      {radarId:8,lon:37.26,lat:55.59,info:"RAVN (Внуково)"},
      {radarId:9,lon:30.64,lat:56.39,info:"RAVL (В.Луки)"},
      {radarId:10,lon:44.34,lat:48.79,info:"RUDG (Волгоград)"},
      {radarId:11,lon:39.94,lat:59.28,info:"RUDV (Вологда)"},
      {radarId:12,lon:31.02,lat:52.52,info:"UMGG (Гомель)"},
      {radarId:13,lon:37.52,lat:55.92,info:"RUDE (Долгопрудный)"},
      {radarId:14,lon:60.80,lat:56.75,info:"RUEK (Екатеринбург)"},
      {radarId:15,lon:35.3,lat:47.84,info:"UKDE (Запорожье)"},
      {radarId:16,lon:53.45,lat:56.84,info:"RUDI (Ижевск)"},
      {radarId:17,lon:49.28,lat:55.59,info:"RUDZ (Казань)"},
      {radarId:18,lon:36.33,lat:54.57,info:"RUKL (Калуга)"},
      {radarId:19,lon:49.34,lat:58.50,info:"RAKW (Киров)"},
      {radarId:20,lon:41.01,lat:57.81,info:"RUDK (Кострома)"},
      {radarId:21,lon:39.153,lat:45.04178,info:"RAKD (Краснодар)"},
      {radarId:22,lon:36.13,lat:51.90,info:"RAKU (Курск)"},
      {radarId:23,lon:37.41,lat:55.752,info:"RUKT (Москва)"},
      {radarId:24,lon:28.03,lat:53.88,info:"UMMN (Минск-2)"},
      {radarId:25,lon:30.35,lat:55.14,info:"UMII (Витебск)"},
      {radarId:26,lon:43.108,lat:44.209,info:"RUDM (Минводы)"},
      {radarId:27,lon:43.99,lat:56.293,info:"RUDN (Н.Новгород)"},
      {radarId:28,lon:55.08,lat:51.69,info:"RUDO (Оренбург)"},
      {radarId:29,lon:56.03,lat:57.90,info:"RUPM (Пермь)"},
      {radarId:30,lon:34.25,lat:61.82,info:"RUDP (Петрозаводск)"},
      {radarId:31,lon:39.81,lat:47.25,info:"RURD (Ростов-на-Дону)"},
      {radarId:32,lon:49.385,lat:52.96,info:"RASM (Самара)"},
      {radarId:33,lon:32.00,lat:54.85,info:"RUDL (Смоленск)"},
      {radarId:34,lon:39.85,lat:43.54,info:"RUSI (Сочи)"},
      {radarId:35,lon:30.22,lat:59.80,info:"RUSP (СПБ)"},
      {radarId:36,lon:42.10,lat:45.11,info:"RUDT (Ставрополь)"},
      {radarId:37,lon:35.99,lat:56.814,info:"RUTW (Тверь)"},
      {radarId:38,lon:38.13,lat:54.00,info:"RATL (Тула)"},
      {radarId:39,lon:48.21,lat:54.26,info:"RUUL (Ульяновск)"},
      {radarId:40,lon:24.049,lat:53.652,info:"UMMG (Гродно)"}
    ];
    let indexesRadarsList = {};
    radarsList.forEach(v => {
      let key = v.info.split(' (')[0]
      indexesRadarsList[key] = v.radarId
    });
    for(let i = 0; i < radarsList.length; i++) {
      radars[i] = layerGroup();
    }
    for(let index = 0; index < this.markers.length; index++) {
      this.markers[index].addTo(this.map);
    }
    let loadedRADARs = []
    await (async () => new Promise((resolve) => {
      this._radar.getFromPHP().subscribe(
        async res => {
          let c = res[0].map(v => {
            let key = Object.keys(v)[0];
            loadedRADARs.push(key.split('.')[0]);
            return v[key]
          });
          radarsRect = [].concat.apply([], c);
          res[1].forEach(v => {
            let tmp = v.split(' ');
            let latlng = tmp[0].replace("markers.push(L.marker([",'').split(']).')[0].split(',');
            let type = tmp[0].split("bindPopup('")[1];
            let msg = `${radarsListNames[type]} ${tmp[2]} ${tmp[3].replace("'))",'')}`
            // console.log(latlng, msg);
            if (!msg.includes('UKBB')) { // del UKBB
              this.markers.push(L.marker(latlng, {
                icon: new L.Icon({
                  // iconSize: [27, 27],
                  iconAnchor: [13, 41],
                  // popupAnchor:  [1, -24],
                  iconUrl: 'assets/marker-icon.png'
                })
              }).bindPopup(msg).on('click', function(e) { this.openPopup();}));
            }
          });
          resolve(1);
        },
        err => []
      );
    }))();
    for(let index = 0; index < radarsRect.length; index++) {
      let res = radarsRect[index].split("_");
      let customLayer = this.makeLayer({
        y: res[0],
        x: res[1],
        radar: res[2],
        color: res[3]
      });
      this.ArrayOfRadarsByRadar[res[2]] = 
        this.ArrayOfRadarsByRadar[res[2]] ? 
        this.ArrayOfRadarsByRadar[res[2]] : [];
      this.ArrayOfRadarsByRadar[res[2]].push(customLayer);
      let layer = new this.MyCustomLayer(res, customLayer);
      radars[layer.radar].addLayer(layer);
      this.setLayer(layer.color).addLayer(layer);
    }
    let overlay = {};
    await (async () => new Promise((resolve) => {
      loadedRADARs.forEach(v => {
        // console.log(v, indexesRadarsList[v], radarsList[indexesRadarsList[v]].info);
        overlay[radarsList[indexesRadarsList[v]].info] = radars[indexesRadarsList[v]];
        if (v != 'UKBB') { // del UKBB 
          this.btnsPlaceRadars.push({
            title: radarsList[indexesRadarsList[v]].info,
            active: false,
            radar: indexesRadarsList[v]
          });
        }
      });
      for(let index = 0; index < this.markers.length; index++) {
        this.markers[index].addTo(this.map);
      }
      resolve(1);
    }))();
    await (async () => new Promise((resolve) => {
      this.btnsPlaceRadars.forEach((v, i) => {
        this.changeViewLayer(i);
      });
    resolve(1);
    }))();
  }
  include(arr, obj) {
    for(let i = 0; i < arr.length; i++) {
        if (arr[i] == obj) return true;
    }
    return false;
  }
  checkLayer(map,layersSet,layer) {
    for(let i = 0; i < layersSet.length; i++) {
      if(map.hasLayer(layersSet[i])) {
        continue;
      }
      if(layersSet[i].hasLayer(layer))
        return 0;
    }

    return 1;
  }
  MyCustomLayer = L.Class.extend({

    initialize: function (infArray) {
        // save position of the layer or any options from the constructor
      this.y = infArray[0];
      this.x = infArray[1];
      this.radar = infArray[2];
      this.color = infArray[3];
    },
    onAdd: function (map) {
    },
    onRemove: function (map) {
    },
    setlayer: function(infArray, makedLayer) {
      this.layerAssoc = makedLayer
    },
    resetlayer:function() {
      this.layerAssoc=null;
    },
  });
  makeLayer(radarRect){
    var size = 2.1;
    var res = radarRect;
    var x = res.x;
    var y = res.y;
    var RadarId = res.radar;
    var Color = res.color;
    var Radius = 6371000;
    Radius=Radius-(y*y)/90/90*6500000;
    var y1=Radius*Math.log(Math.tan(Math.PI/4 + this.Mathradians(y/2)))-size*1000;
    var y2=Radius*Math.log(Math.tan(Math.PI/4 + this.Mathradians(y/2)))+size*1000;
    y1=this.Mathdegrees((Math.atan(Math.exp(y1/Radius))-Math.PI/4)*2);
    y2=this.Mathdegrees((Math.atan(Math.exp(y2/Radius))-Math.PI/4)*2);
    var x1 = Radius*this.Mathradians(x)+size*1000;
    var x2 = Radius*this.Mathradians(x)-size*1000;
    x2=this.Mathdegrees(x2/Radius);
    x1=this.Mathdegrees(x1/Radius);
    let rectangle = L.rectangle([[y1,x1], [y2,x2]], {
      color: this.getColor(Color), 
      fillColor: this.getColor(Color), 
      stroke: true, 
      fillOpacity: this.density/100,
      weight: 0.7,
      clickable: false, 
      opacity: 0.1
    });
    return rectangle
  }
  setLayer(d){
    return d==19 ? this.meteo[16]:
      d==18 ? this.meteo[16]:
      d==17 ? this.meteo[15]:
      d==16 ? this.meteo[14]:
      d==15 ? this.meteo[13]:
      d==14 ? this.meteo[12]:
      d==13 ? this.meteo[11]:
      d==12 ? this.meteo[10]:
      d==11 ? this.meteo[9]:
      d==10 ? this.meteo[8]:
      d==9 ? this.meteo[7] :
      d==8 ? this.meteo[6] :
      d==7 ? this.meteo[5] :
      d==6 ? this.meteo[4] :
      d==5 ? this.meteo[3] :
      d==4 ? this.meteo[2] :
      d==3 ? this.meteo[1] :
      d==2 ? this.meteo[0] :
      d==1 ? this.meteo[0] :
            this.meteo[0];
  }
  Mathradians = function(degrees) {
		return degrees * Math.PI / 180;
  };
  Mathdegrees = function(radians) {
		return radians * 180 / Math.PI;
  };
  getColor(d) {
    return d==19 ? '#FFFFFF' :
      d==18 ? '#BE1CFF' :
      d==17 ? '#E859FF' :
      d==16 ? '#DDA8FF' :
      d==15 ? '#A84C06' :
      d==14 ? '#FF9811' :
      d==13 ? '#FFEA0A' :
      d==12 ? '#C20511' :
      d==11 ? '#FF3F35' :
      d==10 ? '#FF93A3' :
      d==9  ? '#6153C1' :
      d==8  ? '#0C59FF' :
      d==7  ? '#4793F8' :
      d==6  ? '#9BE1FF' :
      d==5  ? '#47C278' :
      d==4  ? '#58FF42' :
      d==3  ? '#9BEA8F' :
      d==2  ? '#FFFFFF' :
      d==1  ? '#FFFFFF' :
              'black';
  }
  clearRadarMarkers() {
    for(let index = 0; index < this.markers.length; index++) {
      this.markers[index] && this.map.removeLayer(this.markers[index]);
    }
    this.btnsPlaceRadars.forEach((v, i) => {
      this.ArrayOfRadarsByRadar[this.btnsPlaceRadars[i].radar] && this.ArrayOfRadarsByRadar[this.btnsPlaceRadars[i].radar].forEach(v => {
        this.map.removeLayer(v);
      });
    });
    // this.ArrayOfRadarsByRadar = {};
  }



















  // // // TEMPERATURE AGRO // // //
  timeUTC;
  getTimezone() {
    return this.timeUTC ? '+0' : (this.selectedCity.timezone < 0 ? '' + this.selectedCity.timezone : '+' + this.selectedCity.timezone)
  }
  dateText;
  resultLayer;
  intervalsForecastTemperature = [];
  forecastGradientTemperature = ['880015','a349a4',
  '3f48cc','8080ff','006ad5','007dfb','1c8dff','48a4ff',
  '7dbeff','bbddff','88ffc4','00ff00','ffff80','fff200',
  'ffc90e','ff9664','ff7f27','ffaec9','ed1c24'];
  forecastIntervalTemperature = [-32,-28,-24,-20,-16,-12,-8,-4,-2,0,2,4,8,12,16,20,24,28,32]; 
  getForecastColor = (type, d) => {
    type = type[0].toUpperCase() + type.slice(1);
    let check = i => (d > this['intervalsForecastTemperature'][i]) 
      ? this['forecastGradientTemperature'][i] 
      : (i > 0 ? check(i-1) : this['forecastGradientTemperature'][0]);
    return check(123);
  }
  getForecastGradientTemperature() {
    let arr = [];
    let steps = 6;
    this.forecastGradientTemperature = ['880015','a349a4',
    '3f48cc','8080ff','006ad5','007dfb','1c8dff','48a4ff',
    '7dbeff','bbddff','88ffc4','00ff00','ffff80','fff200',
    'ffc90e','ff9664','ff7f27','ffaec9','ed1c24'];
    this.forecastGradientTemperature.forEach((v,i) => {
      if (this.forecastGradientTemperature[i+1]) {
        var r1 = parseInt(v.substr(0, 2),16);
        var g1 = parseInt(v.substr(2, 2),16);
        var b1 = parseInt(v.substr(4, 2),16);
        var r2 = parseInt(this.forecastGradientTemperature[i+1].substr(0, 2),16);
        var g2 = parseInt(this.forecastGradientTemperature[i+1].substr(2, 2),16);
        var b2 = parseInt(this.forecastGradientTemperature[i+1].substr(4, 2),16);
        let rStep = (r2 - r1) / steps;
        let gStep = (g2 - g1) / steps;
        let bStep = (b2 - b1) / steps;
        for(let i2 = 0; i2 < steps; i2++) {
          let r = Number((r1 + rStep * i2).toFixed(0)).toString(16);
          r = r.length === 1 ? '0'+r : r;
          let g = Number((g1 + gStep * i2).toFixed(0)).toString(16);
          g = g.length === 1 ? '0'+g : g;
          let b = Number((b1 + bStep * i2).toFixed(0)).toString(16);
          b = b.length === 1 ? '0'+b : b;
          arr.push(`#${r}${g}${b}`);
        }
      }
    });
    arr.push('#880015');
    arr.unshift('#a349a4');
    this.forecastGradientTemperature = arr;
  }
  async getRangeForecastTemperature() {
    let max = (() => { return 32; })();
    let min = (() => { return -32; })();
    let r = max - min;
    let step = r/120;
    let arr = [];
    for(let i = 0; i <= 120; i++) arr.push(min + step * (i));
    this.intervalsForecastTemperature = [];
    arr.push(60);
    arr.unshift(-60);
    this.intervalsForecastTemperature = arr;
    return 123;
  }
  async getAgroGeoTIFF() {
    this.loading = true;
    this.map.closePopup(); // close all popup
    let tmp2 = await this.getRangeForecastTemperature();
    let tmp5 = await this.getForecastGradientTemperature();
    let t1 = performance.now();

      this._agro.getGeotiff().subscribe(
      async res => {

        var tiff = GeoTIFF.parse(res);
        var image = tiff.getImage();
        var tiffWidth = image.getWidth();
        var tiffHeight = image.getHeight();
        var rasters = image.readRasters();
        var tiepoint = image.getTiePoints()[0];
        var pixelScale = image.getFileDirectory().ModelPixelScale;
        var geoTransform = [tiepoint.x, pixelScale[0], 0, tiepoint.y, 0, -1 * pixelScale[1]];

        var uData = new Array(tiffHeight);
        var spdData = new Array(tiffHeight);
        for (var j = 0; j < tiffHeight; j++) {
          uData[j] = new Array(tiffWidth);
          spdData[j] = new Array(tiffWidth);
          for (var i = 0; i < tiffWidth; i++) {
            uData[j][i] = rasters[0][i + j * tiffWidth];
            spdData[j][i] = 1 * Math.sqrt(uData[j][i] * uData[j][i]);
          }
        }

        let intervals = this.intervalsForecastTemperature;
        let values = uData;
        var bandsWind = rastertools.isobands(values, geoTransform, intervals);

        let style = (feature) => {
          return {
            fillColor: this.getForecastColor('maybe type',feature.properties[0].upperValue),
            weight: 0,
            opacity: 1,
            color: this.getForecastColor('maybe type',feature.properties[0].upperValue),
            dashArray: '0',
            fillOpacity: 0.6
          };
        }

        this.resultLayer && this.map.removeLayer(this.resultLayer);
        this.resultLayer = L.geoJson(bandsWind, {
          style: style
        });

        this.resultLayer.addTo(this.map);


        this.maskBelarus && this.map.removeLayer(this.maskBelarus);
        this.maskBelarusAlpha && this.map.removeLayer(this.maskBelarusAlpha);
        this.maskBelarus.addTo(this.map);
        this.loading = false;
        let t2 = performance.now();
        // console.log("Call to " + (t2 - t1) + " milliseconds.");

        this.map.off('click');
        this.map.on('click', async (e: LeafletMouseEvent) => {
          let xTiff = (e.latlng.lng - geoTransform[0]) / geoTransform[1];
          let yTiff = (e.latlng.lat - geoTransform[3]) / geoTransform[5];
          let uValue = uData[Math.round(yTiff)][Math.round(xTiff)];
          // console.log(xTiff, yTiff, uValue);
          
          let content = () => {
              return `<div>${(Number.isFinite(uValue) ? `${uValue.toFixed(1)}` : '-none-')} °C</div>`;
          }

          let popup = L.popup({
            className: 'small-custom',
            closeButton: false,
            // autoClose: false,
            autoPan: false
          })
            .setLatLng(e.latlng)
            .setContent(content());
          if(Number.isFinite(uValue)) {
            popup.openOn(this.map);
          }
        });

      },
      err => {
        console.error('Forecast geoTIFF', err);
        this.loading = false;
      }
    );
  }
  async getAgroDateGenerate() {
    this._agro.getDateGenerate().subscribe(
      res => {
        this.dateText = res.agro;
      },
      err => {

      }
    )
  }




























  // // CURRENT WEATHER

  getMeteo10Min() {
    this._maps.getMeteo10Min().subscribe(
      res => {
        let getStyleStationMarker = (html,name) => (L.divIcon({ 
          className: 'custom-alex-icon', 
          iconSize: [32, 40], 
          iconAnchor: [16, 40],
          popupAnchor:  [0, -38],
          html: `<div class="name ${
            html <= 0 ? 'blue' : 
            html > 0 && html < 10 ? 'green' : 
            html >= 10 && html < 20 ? 'yellow' : 
            html >= 20 && html < 30 ? 'orange' :
            html >= 30 ? 'red' : 'grey'
          }">${html}</div>
          <div class="icon_arrow ${
            html <= 0 ? 'blue' : 
            html > 0 && html < 10 ? 'green' : 
            html >= 10 && html < 20 ? 'yellow' : 
            html >= 20 && html < 30 ? 'orange' :
            html >= 30 ? 'red' : 'grey'
          }"></div>
          <div class="custom-city-name">${name === 'Минск' ? 'Минск-Уручье': name}</div>` 
        }));
        let getStationMarker = (lat, lng, html, name) => L.marker([lat, lng], { icon: getStyleStationMarker(html, name) });
        this.resultLayer && this.map.removeLayer(this.resultLayer);
        // this.map.on('layeradd', (event) => {
        //   var layer = event.layer;
        //   if (layer instanceof L.Marker && !(layer instanceof L.MarkerCluster)) {
        //     layer.openPopup();
        //   }
        // });
        this.resultLayer = layerGroup();
        res.forEach((v, i) => {
          let Datetime = this.getDateTime(v.description.date);
          let marker = getStationMarker(v.coordinates[1], v.coordinates[0], (v.description.temperature.replace('°C','') || '!'), v.name)
            .on('click', () => {
              // this.map.setView({lat: v.LATITUDE, lng: v.LONGITUDE}, 13);
              // this.zone.run(() => {}); // for rerender map & open item by city
            });
          marker.addTo(this.resultLayer)
          .bindPopup(`
          <div>${v.name} 
            <span>Погода за ${this.getDate(Datetime)}</span>
            ${v.description.temperature ? `<span>Температура воздуха: ${v.description.temperature}</span>` : ''}
            ${v.description.weather ? `<span>Метеоявление: ${v.description.weather}</span>` : ''}
            ${v.description.clouds ? `<span>Облачность: ${v.description.clouds}</span>` : ''}
            ${v.description.wind ? `<span>Ветер: ${v.description.wind}</span>` : ''}
            ${v.description.windGust ? `<span>Максимальный порыв ветра: ${v.description.windGust}</span>` : ''}
            ${v.description.view ? `<span>Видимость: ${v.description.view}</span>` : ''}
            ${v.description.water ? `<span>Влажность: ${v.description.water}</span>` : ''}
            ${v.description.pressStation ? `<span>Давление на уровне станции: ${v.description.pressStation}</span>` : ''}
            ${v.description.pressSea ? `<span>Давление на уровне моря: ${v.description.pressSea}</span>` : ''}
            ${v.description.minTemperature ? `<span>Минимальная температура воздуха: ${v.description.minTemperature}</span>` : ''}
            ${v.description.windGust ? `<span>Максимальный порыв ветра: ${v.description.windGust}</span>` : ''}
            </div>`, {
            className: 'small-custom-big',
            closeButton: false,
            autoClose: false,
            autoPan: false
          });
          marker.on('click', function(e) { marker.openPopup();});
        });
        this.resultLayer.addTo(this.map);
        this.maskBelarus && this.map.removeLayer(this.maskBelarus);
        this.maskBelarusAlpha && this.map.removeLayer(this.maskBelarusAlpha);
        this.maskBelarusAlpha.addTo(this.map);
      },
      err => {}
    );
  }















  // // // HYDRO
  dateTextHydro;
  getGidro() {
    this._hydrology.getHydroMarkers().subscribe(
      res => {
        this.dateTextHydro = new Date(res[0].DateTime);
        let genColorArrow = (item) => {
          if (isFinite(item.ur8) && item.ur8 != null) {
            if (isFinite(item.lowlev) && item.lowlev != null) {
              if (Number(item.ur8) < Number(item.lowlev) ) return 'yellow';
            }
            if (isFinite(item.outlev) && isFinite(item.danglev) && item.outlev != null && item.danglev != null ) {
              if (Number(item.ur8) > Number(item.outlev) &&
                  Number(item.ur8) < Number(item.danglev) ) return 'blue';
            }
            if (isFinite(item.outlev) && item.outlev != null && item.danglev == null ) {
              if (Number(item.ur8) > Number(item.outlev) ) return 'blue';
            }
            if (isFinite(item.danglev) && item.danglev != null) {
              if (Number(item.ur8) > Number(item.danglev) ) return 'red';
            }
            return 'green';
          } else {
            return 'green';
          }
        }
        let getStyleStationMarker = (html, item) => (L.divIcon({ 
          className: 'custom-alex-icon', 
          iconSize: [32, 40], 
          iconAnchor: [16, 40],
          html: `<div class="name grey text-${genColorArrow(item) || 'green'}">${html > 0 ? '▲': html < 0 ? '▼' : '▶'}</div>
          <div class="icon_arrow grey"></div>
          <div class="custom-city-name">${item.punkt}</div>` 
        }));
        let getStationMarker = (lat, lng, html, item) => L.marker([lat, lng], { icon: getStyleStationMarker(html, item) });
        this.resultLayer && this.map.removeLayer(this.resultLayer);
        this.resultLayer = layerGroup();
        function parseLevel(str) {
          // ((Number(v.description.lvlChange.split(' см')[0])) || '!')
          if (str == 0) return "не изменяется";
          if (str < 0) return "падает";
          if (str > 0) return "растет";
        }
        res.forEach((v, i) => {
          let Datetime = v.DateTime ? this.getDateTime(v.DateTime) : null;
          let marker = getStationMarker(v.LATITUDE, v.LONGITUDE, v.izur, v)
            .on('click', () => {
              // this.map.setView({lat: v.LATITUDE, lng: v.LONGITUDE}, 13);
              // this.zone.run(() => {}); // for rerender map & open item by city
            });
          marker.addTo(this.resultLayer)
          .bindPopup(`
          <div class="translate" translate="yes">${v.punkt} 
            <span>${Datetime ? this.getDate(Datetime) : ''}</span>
            ${v.TempAir ? `<span>Температура воды: ${v.TempAir}°C</span>` : ''}
            ${v.reka ? `<span>Название реки: ${v.reka}</span>` : ''}
            ${v.izur ? `<span>Изменение уровня воды: ${parseLevel(v.izur)}</span>` : ''}
            ${v.tol_led ? `<span>Толщина льда: ${v.tol_led}</span>` : ''}
            ${v.ledov ? `<span>Состояние льда: ${v.ledov}</span>` : ''}
            ${v.sosvo ? `<span>Состояние водного объекта: ${v.sosvo}</span>` : ''}
            </div>`, {
            className: 'small-custom-big',
            closeButton: false,
            autoClose: false,
            autoPan: false
          });
          marker.on('click', function(e) { marker.openPopup();});
        });
        this.resultLayer.addTo(this.map);
        this.maskBelarus && this.map.removeLayer(this.maskBelarus);
        this.maskBelarusAlpha && this.map.removeLayer(this.maskBelarusAlpha);
        this.maskBelarusAlpha.addTo(this.map);
      },
      err => {}
    );
  }












  // ngAfterViewChecked() {
  //   this._shared.currentFooterHeight.subscribe(state => {
  //     this.isSmallIcons = this.breakpointObserver.isMatched('screen and (max-width: 1044px)');
  //   });
  //   // if(this.breakpointObserver.isMatched('screen and (max-width: 768px)')) {
  //   //   console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAa')
  //   // }
  //   console.log(window.innerWidth);
  //   this.cdr.detectChanges();
  // }
  ngAfterViewInit() {
    this._shared.currentFooterHeight.subscribe(state => {
      this.isSmallIcons = this.breakpointObserver.isMatched('screen and (max-width: 1044px)');
    });
    if (window.innerWidth < 768) {
      this.showLegend = false;
    }
    this.cdr.detectChanges();
  }

  ngOnInit() {
  
    this._shared.currentCity.subscribe(city => {
      this.selectedCity = city;
      this.canIuseData && this.runAction();
    });
    this._shared.currentTime.subscribe(time => {
      this.timeUTC = time;
      this.canIuseData && this.runAction();
    });
  }

}
